module.exports = __webpack_public_path__ + "img/empty-importing-record.1395deae.svg";